// extracted by mini-css-extract-plugin
module.exports = {"tableBox":"Table_tableBox__1u2fE","headerAll":"Table_headerAll__3OIWx","sliderDiv":"Table_sliderDiv__1BODu","tableDiv":"Table_tableDiv__3Cdtp","tableBody":"Table_tableBody__2stXe"};